import { useEffect } from 'react'

export default function event01({ callback, dataset }) {
  callback();
  console.log({ dataset });
}